import { JSONNode } from '@atlaskit/editor-json-transformer';

import { ExtensionNode } from '../types/Extension';

export const updateSuggestionNodeAttributes = (
  node: JSONNode,
  isEditModeEnabled: boolean,
  getSuggestions?: () => Record<string, string>
) => {
  if (node.type !== 'extension') return;

  let suggestions = null;
  if (getSuggestions) {
    suggestions = getSuggestions();
  }

  const currExtensionNode = node as ExtensionNode;
  const currExtensionNodeAttrs = currExtensionNode.attrs;
  if (
    isEditModeEnabled &&
    currExtensionNodeAttrs.extensionKey === 'codesuggestions:suggestion-node'
  ) {
    const suggestionKey = currExtensionNodeAttrs.localId;
    if (suggestions && suggestions[suggestionKey] !== undefined) {
      // When a suggestion is created/updated, update its node's text attribute to match the suggestion text.
      // This is crucial for the serialization process, as the serializer retrieves the text content
      // from the node's text attribute during the conversion to HTML format.
      currExtensionNodeAttrs.text = suggestions[suggestionKey];

      // In util.ts, when the HTML is transformed back into a node, parameters.suggestionText is set
      // which is what the view card component uses to pull the suggestionText.
      // Setting this parameter prevents temporary display issues where the view card might
      // display a blank suggestion while waiting for the comment to completely save and render.
      currExtensionNodeAttrs.parameters.suggestionText =
        suggestions[suggestionKey];
    } else {
      // If a suggestion node is found unchanged, set the node's text from its parameters.
      // This prevents the issue where the serializer's doesn't have the text content in the node, and ensures
      // consistent suggestionText preservation when transitioning from view to edit mode.
      currExtensionNodeAttrs.text =
        currExtensionNodeAttrs.parameters.suggestionText;
    }
  }
};
